import React, { Component } from 'react'
import { connect } from 'react-redux'
import RefreshIcon from 'react-icons/lib/fa/refresh'
import css from './style.css'
import * as actions from '../../actions/jewelry-search'
import * as cartActions from '../../actions/cart'
import * as settingsActions from '../../actions/settings'
import JewelrySearchFilters from '../../components/jewelry-search-filters'
import JewelryPrice from '../../components/jewelry-price'
import Button from '../../components/button'
import Spacer from '../../components/spacer'
import QuestionList from '../../components/question-list'
import { Grid, GridItem } from '../../components/grid'
import { getCurrentJewelryPrice } from '../../selectors/jewelry-search'
import _ from 'lodash'
import { validateForm } from './validator'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.jewelrySearch,
    ...state.settings,
    currentJewelryPrice: getCurrentJewelryPrice(state),
    user: state.currentUser
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    openModal: (row, e) => {
      dispatch(actions.openModal(row))
      if (e) {
        e.preventDefault()
      }
    },
    closeModal: () => {
      dispatch(actions.closeModal())
    },
    onChangeFilterVal: (key, val) => {
      dispatch(actions.setFilterVal(key, val))
    },
    addJewelry: () => {
      dispatch(cartActions.addCurrentJewelryToCart())
      dispatch(settingsActions.showCart())
    },
    onChangeMultiStoneShapeOrQuality: (key, val) => {
      dispatch(actions.setFilterVal(key, val))
      dispatch(actions.smallDiamondsSearch())
    },
    clearCurrentJewelry: () => {
      dispatch(actions.clearCurrentJewelry())
    },
    displayError: (error) => {
      dispatch(actions.setErrorMsg(error))
    },
    getPrice: () => {
      dispatch(actions.search())
    },
    onClickReset: () => {
      dispatch(actions.reset())
    },
    getCustomOptions: () => {
      Promise.resolve(
        // 1). get custom vertical shank thickness options for shank panel
        dispatch(actions.setVerticalShankThicknesses())
      ).then(() => {
        // 2). get default shank width options for shank panel
        dispatch(actions.setDefaultShankWidths())
      }).then(() => {
        // 3). get default halo width options for multi stone halo panel and centre halo panel
        dispatch(actions.setDefaultHaloWidths())
      })
    }
  }
}

export class Jewelry extends Component {
  componentWillMount () {
    this.props.getCustomOptions()
  }

  render () {
    const props = this.props
    const validate = () => {
      let validationErrors = validateForm(props.filters)
      if (validationErrors.length) {
        validationErrors = validationErrors.map((e) => { return _.includes(e, '_') ? _.startCase(e) : e })
        let errMsg = 'Please select a valid value for: ' + validationErrors.join(', ')
        props.displayError(errMsg)
      } else {
        props.getPrice()
      }
    }
    return (
      <div>
        <div className={css.priceFooter}>
          <JewelryPrice
            price={props.currentJewelryPrice}
            currentJewelryId={props.currentJewelryId}
            onGetPrice={validate}
            result={props.result}
            errorMsg={props.errorMsg}
            addJewelryClicked={() => props.addJewelry()}
            clearCurrentJewelry={props.clearCurrentJewelry}
            currentJewelryPriceIsFresh={props.currentJewelryPriceIsFresh}
            user={props.user} />
        </div>
        <Grid>
          <GridItem col='2/10'>
            <div className={css.questionSidebar}>
              <QuestionList />
              <Button buttonId={'reset_all_btn'} center onClick={props.onClickReset}>
                <RefreshIcon />&nbsp;Reset All
              </Button>
              <Spacer xs />
            </div>
          </GridItem>
          <GridItem col='8/10'>
            <div className={css.filtersMain}>
              <JewelrySearchFilters
                {...props.filters}
                sessionCurrency={props.currency}
                multiStoneSizeOption={props.multiStoneSizeOption}
                verticalShankThicknessOptions={props.verticalShankThicknessOptions}
                defaultShankWidthOptions={props.defaultShankWidthOptions}
                defaultHaloWidthOptions={props.defaultHaloWidthOptions}
                onChangeVal={props.onChangeFilterVal}
                onChangeMultiStoneShapeOrQuality={props.onChangeMultiStoneShapeOrQuality}
                isResetting={props.isResetting}
              />
            </div>
          </GridItem>
        </Grid>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Jewelry)



// WEBPACK FOOTER //
// ./src/containers/jewelry/index.js